import { InfiniteScroll, Lazyload, MessageBox, Toast, Indicator } from 'mint-ui'
import 'mint-ui/lib/style.css'
import '../assets/style/mint-ui-overwrite.styl'

export default function (Vue) {
  Vue.use(InfiniteScroll)
  Vue.use(Lazyload)
  Vue.prototype.$$toast = Toast
  Vue.prototype.$$showLoading = (text = '加载中...') => {
    Indicator.open({
      text,
      spinnerType: 'fading-circle' /* 'snake' 'fading-circle' 'double-bounce' 'triple-bounce' */
    })
  }
  Vue.prototype.$$hideLoading = () => {
    Indicator.close()
  }
  /* MessageBox return promise */
  Vue.prototype.$$msg = MessageBox
  Vue.prototype.$$confirm = MessageBox.confirm
  Vue.prototype.$$alert = MessageBox.alert
}
